import React, { useRef } from 'react';
import { Switch } from 'react-router';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { IRoute } from '../../../routing/AppRoutes';
import { GuestsLayout } from '../../../features/user/expert/guests/GuestsLayout';
import { NewContactCreate } from 'src/pages/journalist/directory/NewContactCreate';

const useStyles = makeStyles(() => ({
  tabsWrapper: {
    padding: '0 24px 16px 24px',
    background: '#fff',
    borderRadius: '10px',

  },
}));

type PNewContacts = {
  routes: Array<IRoute>;
};

export const CreateNewGuestLayout: React.FC<PNewContacts> = (props) => {
  const saveRef = useRef(null);
  return (
    <GuestsLayout
      title="NEW Guest"
      description="Guest you add here are only visible to you"
      saveRef={saveRef}
    >
      <div style={{ background: '#fff', padding: '16px 24px' }}>
        <Switch>
          <NewContactCreate saveRef={saveRef} />
        </Switch>

      </div>
    </GuestsLayout>
  );
};
